/**
 * @flow
 * @relayHash 3a8f202f8c1ff3953569060cadaada03
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JobGenStatus = "FAILED" | "PENDING" | "SKIPPED" | "SUCCESS";
export type GenerateJobsFromOrderInput = {|
  orderId: string,
  orderYieldIds?: ?$ReadOnlyArray<string>,
  skipMaterialCheck?: ?boolean,
|};
export type GenerateJobsFromOrderMutationVariables = {|
  input: GenerateJobsFromOrderInput
|};
export type GenerateJobsFromOrderMutationResponse = {|
  +generateJobsFromOrder: {|
    +result: {|
      +success: number,
      +failed: number,
      +skipped: number,
      +jobs: $ReadOnlyArray<{|
        +id: string,
        +jobNumber: string,
        +workflow: {|
          +id: string,
          +name: string,
        |},
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
      |}>,
      +logs: $ReadOnlyArray<{|
        +id: string,
        +status: JobGenStatus,
        +errorMessage: ?string,
      |}>,
    |}
  |}
|};
export type GenerateJobsFromOrderMutation = {|
  variables: GenerateJobsFromOrderMutationVariables,
  response: GenerateJobsFromOrderMutationResponse,
|};
*/


/*
mutation GenerateJobsFromOrderMutation(
  $input: GenerateJobsFromOrderInput!
) {
  generateJobsFromOrder(input: $input) {
    result {
      success
      failed
      skipped
      jobs {
        id
        jobNumber
        workflow {
          id
          name
        }
        order {
          id
          orderNumber
        }
      }
      logs {
        id
        status
        errorMessage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateJobsFromOrderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateJobsFromOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateJobsFromOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "result",
        "storageKey": null,
        "args": null,
        "concreteType": "GenerateJobsResult",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "success",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "failed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "skipped",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobs",
            "storageKey": null,
            "args": null,
            "concreteType": "Job",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflow",
                "storageKey": null,
                "args": null,
                "concreteType": "Workflow",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "logs",
            "storageKey": null,
            "args": null,
            "concreteType": "JobGenerationLog",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "errorMessage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateJobsFromOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateJobsFromOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateJobsFromOrderMutation",
    "id": null,
    "text": "mutation GenerateJobsFromOrderMutation(\n  $input: GenerateJobsFromOrderInput!\n) {\n  generateJobsFromOrder(input: $input) {\n    result {\n      success\n      failed\n      skipped\n      jobs {\n        id\n        jobNumber\n        workflow {\n          id\n          name\n        }\n        order {\n          id\n          orderNumber\n        }\n      }\n      logs {\n        id\n        status\n        errorMessage\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f28d898e8c676d2fa1c58ada7dc3622';
module.exports = node;
